import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static targets = ["template"];
  static values = { replyBody: String };

  connect() {
    this.modal = document.getElementById("application_modal");
    this.offerFullText = this.offerFullText.bind(this);
    this.modal?.addEventListener("shown.bs.modal", this.offerFullText);
    if (this.modal?.classList.contains("show")) this.offerFullText();
  }

  disconnect() {
    this.modal?.removeEventListener("shown.bs.modal", this.offerFullText);
  }

  use({ currentTarget }) {
    const box = document.getElementById(this.replyBodyValue);
    if (!box) return;
    box.value = this.#text(currentTarget.closest(".voe-reply-template")).textContent;
    box.dispatchEvent(new Event("input", { bubbles: true }));
    Modal.getInstance(this.modal)?.hide();
    box.focus();
  }

  toggle({ currentTarget }) {
    const expanded = currentTarget.closest(".voe-reply-template").classList.toggle("is-expanded");
    currentTarget.setAttribute("aria-expanded", expanded);
    currentTarget.textContent = expanded ? "Show less" : "Show full text";
  }

  // Heights are only known once the dialog is showing, so the toggle is offered then, on the templates that
  // don't fit their preview.
  offerFullText() {
    this.templateTargets.forEach((template) => {
      const text = this.#text(template);
      template.querySelector(".voe-reply-template-more").hidden = text.scrollHeight <= text.clientHeight;
    });
  }

  #text(template) {
    return template.querySelector(".voe-reply-template-text");
  }
}
